import type {
  Expense, ExpenseCategory, ExpenseCategoryCreate, ExpenseCategoryUpdate, ExpenseCreate, ExpenseReport, ExpenseUpdate,
} from '@erp/shared';

import { api } from './api.js';

export interface ExpenseFilter {
  from?: string;
  to?: string;
  status?: string;
  /** One branch (warehouse). */
  warehouseId?: string;
}

export async function listExpenses(filter: ExpenseFilter = {}): Promise<Expense[]> {
  const q = new URLSearchParams();
  if (filter.from) q.set('from', filter.from);
  if (filter.to) q.set('to', filter.to);
  if (filter.status) q.set('status', filter.status);
  if (filter.warehouseId) q.set('warehouseId', filter.warehouseId);
  const qs = q.toString();
  return (await api().get<{ items: Expense[] }>(`/expenses${qs ? `?${qs}` : ''}`)).data.items;
}

export async function createExpense(input: ExpenseCreate): Promise<Expense> {
  return (await api().post<Expense>('/expenses', input)).data;
}

export async function updateExpense(id: string, input: ExpenseUpdate): Promise<Expense> {
  return (await api().patch<Expense>(`/expenses/${id}`, input)).data;
}

export async function getExpenseReport(filter: ExpenseFilter = {}): Promise<ExpenseReport> {
  const q = new URLSearchParams();
  if (filter.from) q.set('from', filter.from);
  if (filter.to) q.set('to', filter.to);
  if (filter.warehouseId) q.set('warehouseId', filter.warehouseId);
  const qs = q.toString();
  return (await api().get<ExpenseReport>(`/expenses/report${qs ? `?${qs}` : ''}`)).data;
}

export async function voidExpense(id: string): Promise<Expense> {
  return (await api().post<Expense>(`/expenses/${id}/void`, {})).data;
}

/** Delete an expense: reverses its GL entry (if any) and removes it from the list. */
export async function deleteExpense(id: string): Promise<void> {
  await api().delete(`/expenses/${id}`);
}

export async function listExpenseCategories(): Promise<ExpenseCategory[]> {
  return (await api().get<{ items: ExpenseCategory[] }>('/expenses/categories')).data.items;
}

export async function createExpenseCategory(input: ExpenseCategoryCreate): Promise<ExpenseCategory> {
  return (await api().post<ExpenseCategory>('/expenses/categories', input)).data;
}

export async function updateExpenseCategory(
  id: string,
  input: ExpenseCategoryUpdate,
): Promise<ExpenseCategory> {
  return (await api().patch<ExpenseCategory>(`/expenses/categories/${id}`, input)).data;
}
